import React from "react";

export const GreenEnergyGenerationTitles = [
  "Timelapse Shell Moerdijk",
  "Zonnepark Sas van Gent-Zuid",
  "",
  "Off shore wind park Vlissingen",
  "GZI Next Zonnepark Emmen",
  "Cross Wind",
  "Windpark op zee Hollandse Kust (noord)"
]

export const GreenEnergyGeneration = [
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">
      Timelapse Shell Moerdijk - Opening 14 maart 2019 | Durvers en Doeners
    </h4>
    <div class="video_container">
      <video width="320" height="240" controls>
        <source
          src="videos/Timelapse Shell Moerdijk - Opening 14 maart 2019   Durvers en Doeners.mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
        <img src="images/qr/qr-green-energy-gen-success-story-video-01.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <div className="slideContainer slide_TextImageRight">
    <h4 className="slideTitle">Zonnepark Sas van Gent-Zuid</h4>
    <div className="slideText">
      <p>
        Shell opende in maart 2022 officieel zonnepark Sas van Gent-Zuid, een
        jaar nadat de bouw startte. Het zonnepark staat op voormalig industrieel
        terrein, ontrokken aan het zicht, op wat ooit de vloeivelden van de
        toenmalige suikerfabriek was. Het zonnepark is 24 hectare groot, telt
        ruim 55.000 zonnepanelen en levert jaarlijks ongeveer 30 gigawatt/uur
        (GWh) aan stroom. Dit leidt naar verwachting tot een besparing van 16,7
        kiloton CO₂-uitstoot per jaar.
      </p>
      <p>
        Shell officially opened solar park Sas van Gent-Zuid in March 2022, a
        year after construction started. The solar park stands on a former
        industrial site, hidden from view, on what were once the flow fields of
        a sugar factory. The solar park is 24 hectares in size, has more than
        55,000 solar panels and supplies about 30 gigawatts/hour (GWh) of
        electricity annually. This is expected to lead to savings of 16.7
        kilotonnes of CO₂ emissions per year.
      </p>
    </div>
    <div className="slideImage">
      <img
        src="images/Zonnepark-Sas-van-Gent-Zuid.jpg"
        alt=""
        width="560"
        height="auto"
      />
    </div>
  </div>,
  <>
    <div className="slideContainer slide_solidColour">
      <div className="colLeft col50">
        <p class="statsIntro">
          <strong>
            “Dit zonnepark is een belangrijke stap om onze duurzaamheidsambities
            te bereiken. Sas van Gent had in 2020 maar liefst 1.174 zonuren. Het
            is een van de zonnigste plekken van Nederland."
          </strong>
          <br />
          <br />
          Ben van Assche, wethouder gemeente Terneuzen
        </p>
      </div>
      <div className="colRight col50 solidColourContainer stats">
        <div class="d-flex">
          <p className="figureContainer">
            <span className="figure">30 MW</span>
            <br />
            capaciteit / capacity
          </p>
          <p className="figureContainer">
            <span className="figure">55.000+</span>
            <br />
            zonnepanelen / solar panels
          </p>
        </div>
      </div>
    </div>
  </>,
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">Bekijk nu Stefan's verhaal | #MakeTheFuture</h4>
    <div class="video_container">
      <video width="320" height="240" controls>
        <source
          src="videos/Bekijk nu Stefan's verhaal MakeTheFuture.mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
      <img src="images/qr/qr-green-energy-gen-success-story-video-03.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">GZI Next Zonnepark Emmen</h4>
    <div class="video_container">
      <video width="320" height="240" controls>
        <source src="videos/GZI Next Zonnepark Emmen.mp4" type="video/mp4" />
      </video>
    </div>
    <div className="qrCode">
      <div className="qrText">
        <p>
          <span>Scan the QR code</span> to watch the video on YouTube.
        </p>
      </div>
      <div className="qrImage">
      <img src="images/qr/qr-green-energy-gen-success-story-video-04.svg" width="auto" height="95px" alt="" />
      </div>
    </div>
  </div>,
  <div className="slideContainer slideContainerVideo">
    <h4 className="slideTitle">Een heel slim windpark</h4>
    <img
      src="images/Een-heel-slim-windpark.jpg"
      alt=""
      width="100%"
      height="auto"
    />
  </div>,
  <>
    <div className="slideContainer slide_solidColour">
      <div className="colLeft col80">
        <h4 className="slideTitle">Windpark op zee Hollandse Kust (noord)</h4>

        <p>
          Voor de kust van Egmond aan Zee komt een nieuw windpark. Consortium
          Crosswind, een joint venture van Shell Nederland en Eneco, won in juli
          2020 de aanbesteding van het subsidievrije windpark op zee Hollandse
          Kust (noord). Het consortium is van plan het park in 2023 in gebruik
          te nemen. Het windpark zal een geïnstalleerd vermogen hebben van in
          totaal 759 MW en levert ten minste 3,3 TWh per jaar. Dit is
          vergelijkbaar met 2,8% van de Nederlandse elektriciteitsvraag. Het
          windpark komt op 18,5 kilometer van de Nederlandse kust bij Egmond aan
          Zee te staan. Dit windpark is een belangrijk onderdeel van een nieuwe
          waardeketen – van wind tot waterstof – met Shell’s ambitie een groene
          waterstoffabriek in Rotterdam te bouwen en met NortH2 te ontwikkelen.
        </p>
        <h4 className="slideTitle">Windpark op zee Hollandse Kust (noord)</h4>
        <p>
          Offshore windprojecten produceren niet continu elektriciteit. Het
          balanceren van deze dalen en pieken en het integreren van deze
          elektriciteit in het nationale energiesysteem vereist nieuwe
          technologieën. Daarom zal het offshore windpark de volgende vijf
          technologische demonstraties bevatten die in de toekomst grootschalig
          gebruikt kunnen worden: een drijvend zonnepark; accu-opslag voor de
          korte termijn; turbines die optimaal zijn afgestemd op elkaar om de
          onderlinge negatieve 'windschaduw'-effecten te beperken; 'groene
          waterstof' gemaakt door elektrolyse als een andere opslagtechniek en
          de combinatie van deze individuele maatregelen tezamen om een continue
          stroomvoorziening te garanderen, ongeacht de windsituatie. De lessen
          die geleerd worden bij de ontwikkeling van dit windpark zullen met een
          breder publiek – in de academische wereld en daarbuiten – gedeeld
          worden.
        </p>
      </div>
      <div className="colRight col20 solidColourContainer stats align-self-start">
        <div class="d-flex">
          <p className="figureContainer text-center">
            <span className="figure">759</span>
            <br />
            MW
          </p>
        </div>
      </div>
    </div>
  </>,
];
